"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ipAccessRuleAdd = ipAccessRuleAdd;
exports.ipAccessRuleDelete = ipAccessRuleDelete;
exports.ipAccessRuleList = ipAccessRuleList;
exports.ipBanConfigInfo = ipBanConfigInfo;
exports.ipBanConfigUpdate = ipBanConfigUpdate;
exports.ipBanRecordList = ipBanRecordList;
exports.ipBanRecordUnban = ipBanRecordUnban;
exports.ipRateRuleAdd = ipRateRuleAdd;
exports.ipRateRuleDelete = ipRateRuleDelete;
exports.ipRateRuleList = ipRateRuleList;
exports.ipRateRuleSwitch = ipRateRuleSwitch;
exports.ipRateRuleUpdate = ipRateRuleUpdate;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

// ==================== 全局配置 ====================

// 获取全局配置
function ipBanConfigInfo() {
  return (0, _request.default)({
    url: '/admin/platform/ip/ban/config/info',
    method: 'get'
  });
}

// 更新全局配置
function ipBanConfigUpdate(data) {
  return (0, _request.default)({
    url: '/admin/platform/ip/ban/config/update',
    method: 'post',
    data: data
  });
}

// ==================== 接口限流规则 ====================

// 限流规则列表
function ipRateRuleList(params) {
  return (0, _request.default)({
    url: '/admin/platform/ip/ban/rate/rule/list',
    method: 'get',
    params: params
  });
}

// 新增限流规则
function ipRateRuleAdd(data) {
  return (0, _request.default)({
    url: '/admin/platform/ip/ban/rate/rule/add',
    method: 'post',
    data: data
  });
}

// 编辑限流规则
function ipRateRuleUpdate(data) {
  return (0, _request.default)({
    url: '/admin/platform/ip/ban/rate/rule/update',
    method: 'post',
    data: data
  });
}

// 启用/禁用限流规则
function ipRateRuleSwitch(id) {
  return (0, _request.default)({
    url: "/admin/platform/ip/ban/rate/rule/switch/".concat(id),
    method: 'post'
  });
}

// 删除限流规则
function ipRateRuleDelete(id) {
  return (0, _request.default)({
    url: "/admin/platform/ip/ban/rate/rule/delete/".concat(id),
    method: 'post'
  });
}

// ==================== 黑白名单 ====================

// 黑白名单列表
function ipAccessRuleList(params) {
  return (0, _request.default)({
    url: '/admin/platform/ip/ban/access/rule/list',
    method: 'get',
    params: params
  });
}

// 添加黑/白名单
function ipAccessRuleAdd(data) {
  return (0, _request.default)({
    url: '/admin/platform/ip/ban/access/rule/add',
    method: 'post',
    data: data
  });
}

// 删除黑/白名单
function ipAccessRuleDelete(id) {
  return (0, _request.default)({
    url: "/admin/platform/ip/ban/access/rule/delete/".concat(id),
    method: 'post'
  });
}

// ==================== 封禁记录 ====================

// 封禁记录列表
function ipBanRecordList(params) {
  return (0, _request.default)({
    url: '/admin/platform/ip/ban/record/list',
    method: 'get',
    params: params
  });
}

// 手动解封
function ipBanRecordUnban(id, resetCount) {
  return (0, _request.default)({
    url: "/admin/platform/ip/ban/record/unban/".concat(id),
    method: 'post',
    params: {
      resetCount: resetCount
    }
  });
}